import { EventPageType } from '@graphql/generated-base';
import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { isMapLayout } from '../../widgets/WeddingMap/weddingMapPinSettings';

/**
 * Whether a layout should hide its title and page note: the map page under
 * the immersive layout. The couple's saved layout (`page.layoutType`) decides
 * when there is one, as it does for the map itself (`resolveMapLayout`);
 * otherwise the flag does, and the title stays hidden while it resolves so it
 * cannot flash. Brannan keeps them mounted but hidden, so they fade in if the
 * answer is no; Aloha passes none, and its title appears without a fade. Both
 * turn inline editing off for them.
 */
export const useHidesMapPageTitle = (pageType: EventPageType | null | undefined, savedLayout?: string | null): boolean => {
  const isMapPage = pageType === EventPageType.map;
  const hasSavedLayout = isMapLayout(savedLayout);
  // Skipped elsewhere and when a saved layout decides; no exposure, because `WeddingMap`'s own read is the one that shows the layout.
  const [isImmersiveLayout, isLoading] = useIsFeatureEnabled('weddingMapImmersiveLayout', { skip: !isMapPage || hasSavedLayout, shouldTrackExposure: false });
  if (!isMapPage) {
    return false;
  }
  return hasSavedLayout ? savedLayout === 'immersive' : isImmersiveLayout || isLoading;
};
